import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { publicRoutes, authRoutes } from '../routes';
import AdminRoute from './AdminRoute';
import VerifiedRoute from './VerifiedRoute';
import AdminPanel from './AdminPanel';
import PrintProduct from './PrintProduct';
import UserOrders from './UserOrders';
import Profile from '../pages/Profile';

const AppRouter = () => {
    return (
        <Routes>
            {/* Явный маршрут для админ-панели */}
            <Route path="/admin" element={
                <AdminRoute>
                    <AdminPanel />
                </AdminRoute>
            } />
            {/* Добавляем защищённые маршруты */}
            {authRoutes.map(({ path, Component }) =>
                <Route
                    key={path}
                    path={path}
                    element={
                        <AdminRoute>
                            <Component />
                        </AdminRoute>
                    }
                />
            )}
            {/* Публичные маршруты, не требующие верификации */}
            {publicRoutes.map(({ path, Component }) =>
                <Route key={path} path={path} element={<Component />} />
            )}
            {/* Защищенные маршруты, требующие верификации */}
            <Route path="/print/:id" element={
                <VerifiedRoute>
                    <PrintProduct />
                </VerifiedRoute>
            } />
            <Route path="/orders" element={
                <VerifiedRoute>
                    <UserOrders />
                </VerifiedRoute>
            } />
            <Route path="/profile" element={
                <VerifiedRoute>
                    <Profile />
                </VerifiedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default AppRouter;